import React from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Input, InputProps } from "antd";
import "./index.scss"

interface SearchInputProps<T> extends Omit<InputProps, 'value' | 'onChange' | 'disabled'> {
  value: T;
  disabled?: boolean;
  onChange: (value: T) => void;
}

const SearchInput = <T extends string | number>({
  value,
  disabled,
  onChange,
  ...rest
}: SearchInputProps<T>) => {
  return (
    <Input
      placeholder="Search..."
      prefix={<SearchOutlined style={{ color: "#7a7a7a"}}/>}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value as T)}
      className="search-input"
      {...rest}
    />
  );
};

export default SearchInput;
